import { PublicPath, publicRoutes } from './public';
import { PrivatePath, privateRoutes } from './private';

export const Path = {
    public: PublicPath,
    private: PrivatePath,
};

export const Routes = {
    public: publicRoutes,
    private: privateRoutes,
};
